import React from 'react';
import { createUseStyles } from 'react-jss';
import { useFormikContext, useField } from 'formik';
import { classNames } from 'primereact/utils';
import MzErrorMessage from './MzErrorMessage';
import { Dropdown } from 'primereact/dropdown';

function MzFormDropdown({ name, label, options }) {
    const [field, , helpers] = useField(name);
    const { setFieldTouched, errors, touched } = useFormikContext();

    const handleChange = (e) => {
        helpers.setValue(e.value);
        setFieldTouched(name, true, false);
    };

    return (
        <div className="field  w-full">
            <label>{label}</label>
            <span className="w-full">
                <Dropdown 
                    id={name} 
                    name={name} 
                    value={field.value} 
                    options={options} 
                    onChange={handleChange} 
                    //placeholder="Select"
                    className="w-full"
                />
            </span>
            <MzErrorMessage error={errors[name]} visible={touched[name]} />
        </div>
    );
}

const styles = createUseStyles({
    container: {}
});

export default MzFormDropdown;
